import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { Select2Data } from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    watch,
    control,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();

      // finalData.append(
      //   "size_id",
      //   JSON.stringify(data.size_id.map((option) => option.value)),
      // );

      // finalData.append(
      //   "diamond_id",
      //   JSON.stringify(data.diamond_id.map((option) => option.value)),
      // );

      finalData.append("name", data?.name);
      const response = await postData(`/admin/masters/metal`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const [Variants, setVariant] = useState([]);
  const getAllVariant = async () => {
    const response = await getData(
      `/common/masters/all-size`,
    );
    if (response?.success) {
      setVariant(await Select2Data(response?.data, "size_id"));
    }
  };

  const [Diamonds, setDiamond] = useState([]);
  const getAllDiamond = async () => {
    const response = await getData(
      `/common/masters/all-diamond`,
    );
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };

  useEffect(() => {
    getAllVariant();
    getAllDiamond();
  }, []);
  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Colour
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Colour</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Colour"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Colour is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Variant</Form.Label>
                    </div>
                    <InputGroup>
                      <Controller
                        className="select-contoller"
                        name={`size_id`} // name of the field
                        control={control}
                        rules={{
                          // required: "Select Variant",
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <Select
                            isMulti
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors?.size_id
                                  ? "red"
                                  : baseStyles.borderColor,
                              }),
                            }}
                            // {...field}
                            options={Variants}
                            onChange={(selectedValue) => {
                              onChange(selectedValue);
                            }}
                            onBlur={onBlur}
                            value={value}
                            ref={ref}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.size_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.size_id.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Diamonds</Form.Label>
                    </div>
                    <InputGroup>
                      <Controller
                        className="select-contoller"
                        name={`diamond_id`} // name of the field
                        control={control}
                        rules={{
                          // required: "Select Diamonds",
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <Select
                            isMulti
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors?.diamond_id
                                  ? "red"
                                  : baseStyles.borderColor,
                              }),
                            }}
                            // {...field}
                            options={Diamonds}
                            onChange={(selectedValue) => {
                              onChange(selectedValue);
                            }}
                            onBlur={onBlur}
                            value={value}
                            ref={ref}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.diamond_id && (
                     <span className="text-danger" style={{ fontSize: "14px" }} >
                        {errors.diamond_id.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
